(function () {
  document.querySelectorAll('[data-pz-pills="size"]').forEach(function (group) {
    if (group.dataset.sizePickerBound) return;
    group.dataset.sizePickerBound = 'true';

    group.addEventListener('click', function (e) {
      var btn = e.target.closest('.pz__pill');
      if (!btn) return;

      group.querySelectorAll('.pz__pill').forEach(function (p) { p.classList.remove('is-active'); });
      btn.classList.add('is-active');

      var currentEl = document.querySelector('[data-pz-size-current]');
      if (currentEl) currentEl.textContent = btn.dataset.short || btn.dataset.value;
    });
  });
})();
